import { render, staticRenderFns } from "./goal_add.vue?vue&type=template&id=a8442512&scoped=true&"
import script from "./goal_add.vue?vue&type=script&lang=js&"
export * from "./goal_add.vue?vue&type=script&lang=js&"
import style0 from "./goal_add.vue?vue&type=style&index=0&id=a8442512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8442512",
  null
  
)

export default component.exports